import { FC } from "react";

interface QuotesIconSVGProps {
    className?: string;
}

const QuotesIconSVG: FC<QuotesIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="77"
            height="57"
            viewBox="0 0 77 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M50.2399 29.7198C53.0488 30.9027 56.1992 31.3833 59.6913 31.1615C60.3115 36.5953 57.4447 49.3704 41.0162 57C49.4303 56.2237 67.6781 50.8121 73.3561 35.3755C75.7854 30.3483 77 25.3949 77 20.5156C77 14.1576 75.254 9.16731 71.7618 5.54474C68.3457 1.84825 63.7908 0 58.0971 0C53.1626 0 49.0632 1.51556 45.7989 4.54669C42.6104 7.50389 41.0162 11.3482 41.0162 16.0798C41.0162 19.2587 41.8513 22.0311 43.5214 24.3969C45.1915 26.6887 47.431 28.463 50.2399 29.7198Z"
                fill="#5A5A60"
            />
            <path
                d="M9.22369 29.7198C12.0326 30.9027 15.183 31.3833 18.6751 31.1615C19.2953 36.5953 16.4285 49.3704 0 57C8.41413 56.2237 26.6619 50.8121 32.3399 35.3755C34.7692 30.3483 35.9838 25.3949 35.9838 20.5156C35.9838 14.1576 34.2377 9.16731 30.7456 5.54474C27.3295 1.84825 22.7746 0 17.0809 0C12.1464 0 8.04702 1.51556 4.78266 4.54669C1.59422 7.50389 0 11.3482 0 16.0798C0 19.2587 0.835068 22.0311 2.5052 24.3969C4.17534 26.6887 6.41483 28.463 9.22369 29.7198Z"
                fill="#5A5A60"
            />
        </svg>
    );
};

export default QuotesIconSVG;
